import { useState, useEffect } from "react";
import "./Stepper.scss";
import GreenButton from "../GreenButton/GreenButton";
import api from "../../utils/api";
import moment from "moment";
import { toast } from "react-toastify";

const Stepper = ({ order, orderId, wholeOrderCanceled }) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [isOrderCanceled, setIsOrderCanceled] = useState(false);

  // console.log(order);
  // console.log(orderId);
  console.log(wholeOrderCanceled);

  useEffect(() => {
    if (order) {
      setIsOrderCanceled(order.cancel_order || false);

      // Find the last status where is_select is true
      const selectedStatuses = order.order_status?.filter(
        (status) => status.is_select
      );

      if (selectedStatuses && selectedStatuses.length > 0) {
        // Get the last selected status (highest ID or last in sequence)
        const lastSelectedStatus =
          selectedStatuses[selectedStatuses.length - 1];
        setCurrentStep(lastSelectedStatus.id);
      }
    }
  }, [order]);

  // Status IDs mapping
  const STATUS_IDS = {
    WAITING_APPROVAL: 1, // انتظار الموافقة
    PROCESSING: 2, // جاري التجهيز
    DELIVERING: 3, // جاري التوصيل
    DELIVERED: 4, // تم التسليم
  };

  const getNextStatusId = (currentStatusId) => {
    // Ensure we move to the next valid status (1 -> 2 -> 3 -> 4)
    if (currentStatusId >= STATUS_IDS.DELIVERED) {
      return STATUS_IDS.WAITING_APPROVAL; // Cycle back to first status if needed
    }
    return currentStatusId + 1;
  };

  const handleChangeStatus = async (statusId) => {
    if (isOrderCanceled || wholeOrderCanceled === "canceled") {
      toast.info("لا يمكن تغير حالة طلب ملغي");
      return;
    }

    try {
      setLoading(true);
      const response = await api.post("/changeStatusOrder", {
        status_id: statusId,
        order_id: orderId,
        vendor_id: order?.vendor?.id,
      });

      if (response.data && response.data.status === 200) {
        setCurrentStep(statusId);

        // Extract only the product IDs from the response
        const matchedProductIds = [];
        if (response.data.data && response.data.data.vendor_products) {
          response.data.data.vendor_products.forEach((vendorProduct) => {
            if (
              vendorProduct.products &&
              Array.isArray(vendorProduct.products)
            ) {
              vendorProduct.products.forEach((product) => {
                matchedProductIds.push(product.id);
              });
            }
          });
        }
      } else {
        console.error("Failed to update order status");
      }
    } catch (error) {
      console.error("Error updating order status:", error);
    } finally {
      setLoading(false);
    }
  };

  const renderCancelOverlay = () => {
    if (!isOrderCanceled) return null;
    return (
      <div className="cancel-overlay">
        <p className="cancel-text">تم الغاء الطلب</p>
      </div>
    );
  };

  return (
    <div className="stepper">
      {renderCancelOverlay()}
      <p className="title">حالة الطلب</p>
      <div className="steps">
        {order?.order_status?.map((status) => (
          <div
            key={status.id}
            className={`step ${currentStep >= status.id ? "active" : ""}`}
          >
            <p className="circle"></p>
            <div className="content">
              <p className="statue">{status.name}</p>
              <p className="date">
                {moment(status?.created_at).format("YYYY/MM/DD hh:mm a")}
              </p>
            </div>
          </div>
        ))}
      </div>
      {!isOrderCanceled && (
        <div className="actions-btns">
          {/* <ColorButton
            size="medium"
            text="الحالة التالية"
            onClick={() => handleChangeStatus(getNextStatusId(currentStep))}
            disabled={loading || currentStep === 4}
          /> */}
          <GreenButton
            size="medium"
            text="تاكيد الحالة التالية"
            variant="fill"
            onClick={() => handleChangeStatus(getNextStatusId(currentStep))}
            disabled={loading || currentStep === 4}
            loading={loading}
          />
        </div>
      )}
    </div>
  );
};

export default Stepper;
